import React from "react";
import { FormattedMessage } from "react-intl";
import { IconButton } from "theme/components/atoms/Button";

import { H4 } from "theme/components/atoms/Typography/Heading";
import ProductAddedPopInActions from "./ProductAddedPopInActions";
import RelatedProducts from "theme/modules/ProductList/RelatedProducts";

const ProductAddedPopInContent = (props) => {
  return (
    <div className="product-added_background">
      <IconButton
        icon="cross"
        size="small"
        appearance="icon"
        title="close"
        onClick={props.hidePopin}
      />
      <section className="product-added__wrapper">
        <div className="product-added__title">
          <H4>
            <FormattedMessage
              id="modules.ProductAddedPopIn.title"
              defaultMessage="Item added to cart !"
            />
          </H4>

          <small>
            <FormattedMessage
              id="modules.ProductAddedPopIn.youAdded"
              defaultMessage="The {name} have been added to your shopping cart"
              values={{
                name: props.product.name,
              }}
            />
          </small>
        </div>

        <ProductAddedPopInActions hidePopin={props.hidePopin} />
      </section>
      {props.product.upsells && props.product.upsells.length > 0 && (
        <div>
          <RelatedProducts products={props.product.upsells} />
        </div>
      )}
    </div>
  );
};

export default ProductAddedPopInContent;
